export const PERMISSION_ABSENCE_TAB = "absences";
export const PERMISSION_VACATION_TAB = "vacations";
export const PERMISSION_LIST_TAB = "permission-list";
